import { useQuery } from "@tanstack/react-query";

export const BETA_TOOL_ACCESS_KEY = "/api/app/beta-tool/access";

export function useBetaToolAccess() {
  const query = useQuery<{ allowed: boolean; canAssign: boolean }>({
    queryKey: [BETA_TOOL_ACCESS_KEY],
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
    refetchOnReconnect: "always",
    refetchInterval: 30_000,
    retry: false,
  });
  return {
    allowed: !query.isError && query.data?.allowed === true,
    canAssign: !query.isError && query.data?.canAssign === true,
    loading: query.isPending,
    error: query.error,
    refetch: query.refetch,
  };
}
